import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "alert alert-ok d-inline-block" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "clearfix" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "s_detail__price-cover" }
const _hoisted_10 = { class: "s_detail__price" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "s_detail__small d-inline-block font-weight-normal" }
const _hoisted_13 = { class: "c_pieces" }
const _hoisted_14 = { class: "c_pieces__cover clearfix" }
const _hoisted_15 = { class: "c_pieces__count" }
const _hoisted_16 = ["min"]
const _hoisted_17 = { class: "s_detail__buy-btn" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "alert alert-diamond d-inline-block" }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 4,
  class: "fs-14 mb-0"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "col-lg-6" }
const _hoisted_25 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_26 = {
  key: 1,
  class: "table table-bordered table-hover table-fs14"
}
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 0,
  class: "s_detail__info",
  "data-toggle": "popover",
  "data-trigger": "click",
  "data-content": "Automaticky příhoz člena <a href=\"/pestitelsky-klub\">Pěstitelského klubu</a>. Více o fungování aukce v <a href=\"/napoveda/aukce\">nápovědě</a>",
  title: "Automaticky příhoz"
}
const _hoisted_29 = { class: "text-right" }

import {ref, computed, watch} from 'vue'

import Alert from '../alert.vue'
import Tooltip from '../tooltip.vue'

import { getCurrencySymbol, formatCurrency, setCookie, getCookie } from "@weseus/cms-core/assets/js/helpers";
import moment from 'moment';
import BidConfirmation from "./BidConfirmation.vue";
import UnfinishedAuctions from "./unfinishedAuctions.vue";


export default {
  __name: 'bidding',
  props: {
	user: { required: true },
	auction: { required: true },
	seller: { required: true },
	flashMessages: { required: true },
	sendBid: { required: true }, // bid function
},
  setup(__props) {

const props = __props

const user = props.user;
const auction = props.auction;
const seller = props.seller;
const flashMessages = props.flashMessages;

const bidConfirmationCookieName = 'bid_confirmation-' + window.location.pathname.substring(1);

const bidAmount = ref(auction.value.currentMinBidMoney.amount / 1000);
const bidAmountInput = ref(null);

const currencyCode = computed(() => {
	return auction.value.currentMinBidMoney.currencyCode;
});

const currencySymbol = computed(() => {
	return getCurrencySymbol(auction.value.currentMinBidMoney.currencyCode, 'cs');
});

const currentBidAmountFormatted = computed(() => {
	if (auction.value.currentBidMoney === null) {
		return formatCurrency(auction.value.initBidMoney.amount / 1000, currencyCode.value, 'cs');
	}

	return formatCurrency(auction.value.currentBidMoney.amount / 1000, currencyCode.value, 'cs');
});

const secPaymentFee = computed(() => {
	return Math.round(bidAmount.value * (auction.value.paymentFeePercent / 100) + (auction.value.paymentFeeFixed.amount / 1000));
});

const secPaymentFeeFormatted = computed(() => {
	return formatCurrency(secPaymentFee.value, currencyCode.value, 'cs');
});

const userMaximumFormatted = computed(() => {
	if (user.value.userMaximum === null) {
		return null;
	}

	return formatCurrency(user.value.userMaximum.amount / 1000, currencyCode.value, 'cs');
});

const urlBecomePremium = computed(() => {
	return `https://${window.location.hostname}/tarif/vyber?productUrl=` + auction.value.url;
});

const urlRechargeWallet = computed(() => {
	return `https://${window.location.hostname}/muj-ucet/penezenka?recharge=` + (bidAmount.value + secPaymentFee.value) + '&product=' + auction.value.url;
});

const walletBalance = computed(() => {
	return user.value.customer.walletBalance.amount / 1000;
});

const showBidConfirmation = ref(false);
const showUnfinishedAuctions = ref(false);

// Clear bidding history before mount
document.getElementById('v_bidding_history').innerHTML = '';

watch(props.auction, (newVal, oldVal) => {
	if (newVal !== null) {
		if (bidAmountInput.value === null || bidAmountInput.value !== document.activeElement) {
			bidAmount.value = newVal.currentMinBidMoney.amount / 1000;
		}

		if (newVal.auctionEnded) {
			flashMessages.value.push({
				type: 'notice',
				message: 'Aukce skončila. Vítězem je ' + newVal.winner.name + '. Děkujeme za účast.',
			});
			setTimeout(() => {
				window.location.reload();
			}, 5000);
		}
	}
})

function bidIncrement() {
	bidAmount.value++;
}

function bidDecrement() {
	bidAmount.value = Math.max(bidAmount.value - 1, auction.value.currentMinBidMoney.amount / 1000);
}

function bid(skipModal = false) {
	if (user.value.customer === null) {
		return;
	}

	if (bidAmount.value < auction.value.currentMinBidMoney.amount / 1000) {
		flashMessages.value.push({
			type: 'notice',
			message: 'Příhoz musí být minimálně ' + auction.value.currentMinBidMoney.amount / 1000 + ' ' + currencySymbol.value + '.',
			timeout: 5000,
		});
		bidAmount.value = auction.value.currentMinBidMoney.amount / 1000;
		return;
	}

	if (user.value.isWinner && (user.value.customer.tariff === 'free')) {
		flashMessages.value.push({
			type: 'notice',
			message: 'Svůj příhoz nemůžete přehodit.',
			timeout: 5000,
		});
		return;
	}

	if (user.value.isWinner && user.value.customer.tariff !== 'free' && bidAmount.value <= user.value.userMaximum.amount / 1000) {
		flashMessages.value.push({
			type: 'notice',
			message: 'Můsíte přihodit více než je vaše nejvyší nabídka.',
			timeout: 5000,
		});
		return;
	}

	if ((auction.value.lastFiveMinutes || auction.value.isPremium) && user.value.customer.tariff === 'free') {
		flashMessages.value.push({
			type: 'notice',
			message: 'Přihodit může jen Premium uživatel. <br><a href="' + urlBecomePremium.value + '">Stát se také premium</a>',
		});
		return;
	}

	if (user.value.customer.phoneVerified === false) {
		flashMessages.value.push({
			type: 'notice',
			message: 'Aukce se můžete žůčastnit jen s ověřeným telefoním číslem.<br><a href="/muj-ucet/overeni-telefonu">Ověřit telefonní číslo</a>',
		});
		return;
	}

	if (user.value.unfinishedAuctions && user.value.unfinishedAuctions.length > 0 && bidAmount.value + secPaymentFee.value > walletBalance.value) {
		showUnfinishedAuctions.value = true;
		return;
	}

	if (skipModal === false && getCookie(bidConfirmationCookieName) !== '1') {
		showBidConfirmation.value = true;
		return;
	}

	props.sendBid({
		bid: {
			amount: bidAmount.value * 1000,
			currencyCode: currencyCode.value,
		},
	});
}

function bidClicked() {
	bid();
}

function bidSubmitted(dismiss) {
	if (dismiss.value) {
		setCookie(bidConfirmationCookieName, '1')
	}
	bid(true);
}


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(user).isWinner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (userMaximumFormatted.value === null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Výborně! V této aukci zatím vedete, vaše aktuální nabídka je " + _toDisplayString(currentBidAmountFormatted.value) + ".", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (userMaximumFormatted.value !== null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Výborně! V této aukci zatím vedete, aktuální nabídka je " + _toDisplayString(currentBidAmountFormatted.value) + ", vaše maximální nabídka je " + _toDisplayString(userMaximumFormatted.value) + ".", 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_unref(auction).biddersCount > 0 && _unref(user).isBidder && _unref(user).isWinner === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "alert alert-false d-inline-block" }, [
            _createElementVNode("p", null, [
              _createTextVNode("Prohráváte někdo vás přehodil,"),
              _createElementVNode("br"),
              _createTextVNode("zkuste ještě přihodit.")
            ])
          ], -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    (_unref(user).customer === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "alert alert-notice d-inline-block" }, [
            _createElementVNode("p", null, [
              _createTextVNode("Přihodit může jen přihlášený uživatel. "),
              _createElementVNode("br"),
              _createElementVNode("a", { href: "/prihlaseni" }, "Přihlásit se")
            ])
          ], -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    _createElementVNode("form", null, [
      _createElementVNode("fieldset", _hoisted_7, [
        (_unref(auction).biddersCount === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Zatím nikdo nepřihodil, buď první!"))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "s_detail__small" }, "Aktuální cena", -1 /* HOISTED */)),
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(currentBidAmountFormatted.value) + " ", 1 /* TEXT */),
              (!_unref(seller).isPremium && _unref(user).customer.tariff === null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(secPaymentFeeFormatted.value) + " poplatek za bezpečnou platbu", 1 /* TEXT */),
                    _createVNode(Tooltip, {
                      class: "s_detail__info",
                      title: "Díky bezpečné platbě máte záruku vrácení peněz v případě, že objednávka nebude odeslána prodejcem. Platba putuje nejdříve k nám a až po potvrzení dodání (případně po uplynutí ochranné lhůty) vyplácíme peníze prodejci. Můžete tedy nakupovat bez obav z podvodů."
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" i ")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "c_pieces__minus",
                onClick: bidDecrement
              }, "−"),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  name: "money",
                  ref_key: "bidAmountInput",
                  ref: bidAmountInput,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((bidAmount).value = $event)),
                  min: _unref(auction).currentMinBidMoney
                }, null, 8 /* PROPS */, _hoisted_16), [
                  [
                    _vModelText,
                    bidAmount.value,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("label", null, _toDisplayString(currencySymbol.value), 1 /* TEXT */)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "c_pieces__plus",
                onClick: bidIncrement
              }, "+")
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-lg",
                disabled: _unref(auction).auctionEnded || _unref(user).customer === null,
                onClick: bidClicked
              }, " Přihodit " + _toDisplayString(_unref(auction).lastFiveMinutes && (_unref(user) === null || _unref(user).tariff === 'free') ? 'a stát se premium' : ''), 9 /* TEXT, PROPS */, _hoisted_18)
            ])
          ])
        ])
      ])
    ]),
    (_unref(auction).lastFiveMinutes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "h6 mb-0 py-03" }, "Nyní už jen pro premium", -1 /* HOISTED */)),
            _createElementVNode("p", null, [
              _cache[8] || (_cache[8] = _createTextVNode(" Posledních 5 minut aukce už je jen pro premium uživatele.")),
              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
              _cache[10] || (_cache[10] = _createTextVNode(" Nechcete nechat nic náhodě? ")),
              _createElementVNode("a", { href: urlBecomePremium.value }, "Staňte se také premium", 8 /* PROPS */, _hoisted_21),
              _cache[11] || (_cache[11] = _createTextVNode(". "))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flashMessages), (flashMessage) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(Alert, _mergeProps({ ref_for: true }, flashMessage), null, 16 /* FULL_PROPS */)
      ]))
    }), 256 /* UNKEYED_FRAGMENT */)),
    (_unref(auction).winner !== null)
      ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
          _cache[13] || (_cache[13] = _createTextVNode(" Vyhrává ")),
          _createElementVNode("a", {
            href: _unref(auction).winner.urlProfile
          }, _toDisplayString(_unref(auction).winner.name), 9 /* TEXT, PROPS */, _hoisted_23),
          _createTextVNode(", Počet přihazujících je: " + _toDisplayString(_unref(auction).biddersCount) + ". ", 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#v_bidding_history" }, [
      _createElementVNode("div", _hoisted_24, [
        (_unref(auction).bids.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_25, "Zatím neproběhl žádný příhoz"))
          : _createCommentVNode("v-if", true),
        (_unref(auction).bids.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_26, [
              _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "Čas"),
                  _createElementVNode("th", { scope: "col" }, "Uživatel"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-right"
                  }, "Hodnota")
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(auction).bids, (bid) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_unref(moment)(bid.date).format('DD.MM. YYYY - HH:mm:ss')), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        href: bid.customer.urlProfile
                      }, _toDisplayString(bid.customer.name), 9 /* TEXT, PROPS */, _hoisted_27),
                      (bid.isProxy)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "i"))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("td", _hoisted_29, _toDisplayString(bid.money.amount / 1000) + " " + _toDisplayString(currencySymbol.value), 1 /* TEXT */)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])),
    _createVNode(BidConfirmation, {
      showModal: showBidConfirmation.value,
      auction: _unref(auction),
      user: _unref(user),
      "bid-amount": bidAmount.value,
      "currency-symbol": currencySymbol.value,
      "url-become-premium": urlBecomePremium.value,
      onSubmit: bidSubmitted,
      onClosed: _cache[1] || (_cache[1] = $event => (showBidConfirmation.value = false))
    }, null, 8 /* PROPS */, ["showModal", "auction", "user", "bid-amount", "currency-symbol", "url-become-premium"]),
    (_unref(user).customer !== null)
      ? (_openBlock(), _createBlock(UnfinishedAuctions, {
          key: 5,
          showModal: showUnfinishedAuctions.value,
          auction: _unref(auction),
          user: _unref(user),
          "recharge-amount": bidAmount.value + secPaymentFee.value - walletBalance.value,
          "currency-code": currencyCode.value,
          "url-recharge-wallet": urlRechargeWallet.value,
          onSubmit: bidSubmitted,
          onClosed: _cache[2] || (_cache[2] = $event => (showUnfinishedAuctions.value = false))
        }, null, 8 /* PROPS */, ["showModal", "auction", "user", "recharge-amount", "currency-code", "url-recharge-wallet"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}